import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function matrimonyProfileDeleteApi(
	payload: RequestDataShape,
	token: string,
) {
	const endpoint = "/matrimony/profile/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
